export default {
    qrIntercom: {
        getOne: ['GET', '/access/qr-intercom/{intercomId}'],
        verifyLocation: ['POST', '/access/qr-intercom/{intercomId}/geofence-verifications'],
    },
    locations: {
        getOne: ['GET', '/access/qr/locations/{entranceId}'],
        checkProximity: ['POST', '/access/qr/locations/{entranceId}/proximity'],
    },
    residents: {
        search: ['GET', '/access/qr/locations/{entranceId}/residents'],
    },
    calls: {
        create: ['POST', '/access/qr/locations/{entranceId}/calls'],
        getStatus: ['GET', '/access/qr/calls/{callId}'],
        hangup: ['POST', '/access/qr/calls/{callId}/hangup'],
        renewToken: ['POST', '/access/qr/calls/{callId}/token'],
    },
};
